import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('transactionCategories', app)
  return store
}
